import { create } from "zustand";

export type Screen = "city" | "island" | "world" | "research" | "military" | "trade";
export type Panel = "building" | "barracks" | "research" | "trade" | "workers" | null;

interface UIStore {
  currentScreen: Screen;
  activePanel: Panel;
  selectedBuildingPosition: number | null;
  selectedResearchType: string | null;

  setScreen: (screen: Screen) => void;
  openPanel: (panel: Panel, buildingPosition?: number) => void;
  openResearchPanel: (researchType: string) => void;
  closePanel: () => void;
}

export const useUIStore = create<UIStore>((set) => ({
  currentScreen: "city",
  activePanel: null,
  selectedBuildingPosition: null,
  selectedResearchType: null,

  setScreen: (screen) => set({ currentScreen: screen, activePanel: null }),
  openPanel: (panel, buildingPosition) =>
    set({ activePanel: panel, selectedBuildingPosition: buildingPosition ?? null }),
  openResearchPanel: (researchType) =>
    set({ activePanel: "research", selectedResearchType: researchType }),
  closePanel: () =>
    set({ activePanel: null, selectedBuildingPosition: null, selectedResearchType: null }),
}));
